import React, { useState } from 'react';
import { ReactComponent as LeftArrow } from 'icons/left-arrow.svg';
import { ReactComponent as AirportIcon } from 'icons/airport-transfer-filled.svg';
import { ReactComponent as PointsIcon } from 'icons/points-icon.svg';
import { Button, InputField, TableWrapper } from 'components/Global';
import { indonesianDateFormat } from 'utils/helpers';
import { checkEmptyObject, getKTPValue, setCurrency } from 'utils/functionality';
import clsx from 'clsx';
import SelectFieldAirportTransferCar from 'components/Global/SelectFieldAirportTransferCar';
import TextAreaInput from 'components/Global/TextArea';
import { getPaymentMethodString } from 'utils/getPaymentMethod';
import { getVehicleById } from 'features/vehicle/action';
import Tabs, { TabPane } from 'components/Global/Tabs';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useAppContext } from 'components/Context/AppContext';
import { downloadOrderDetail } from 'features/order-detail-pdf/actions';
import { getFileName } from 'utils/getFileName';
import { getLocationTimezone } from 'utils/getTimezone';
import { updateOrderCancelation } from 'features/orders/actions';
import { trackEvent } from 'utils/analytics';
import { useFliptBoolean } from '@flipt-io/flipt-client-react';
import { useEffect } from 'react';
import { ReactComponent as Star } from 'icons/star.svg';
import AddOnsField from 'components/Global/AddOnsField';
import { formatPassengerCount } from './special-detail-order';
import { ReactComponent as ReuploadIcon } from 'icons/reupload-icon.svg';
import ImageViewer from 'components/Global/ImageViewer';
import { getConfig } from 'config/runtime';
import ImageNotAvailable from 'components/Global/ImageNotAvailable';

const IMAGE_BASE_URL = getConfig('REACT_APP_IMAGES');

const RegularOrderDetail = ({
  data,
  setShowPriceDifference,
  selectedCar,
  setSelectedCar,
  allVehicle,
  newOrderData,
  oldOrderData,
  customer,
  imagePreviewHandler,
  selectedCountry,
  setShowBankTransferConfirmation,
  isPaymentValid,
  handleProcess,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showToast, setShowRejectOrderModal, setShowReviewIdentityModal, setShowConfirmation, setShowSpinner } =
    useAppContext();

  const [activeTab, setActiveTab] = useState('Data Sekarang');
  const [vehicleInput, setVehicleInput] = useState('');

  const airportPackageVehicle = useSelector((state) => state.airportTransferOrder.selected);
  const vehicleById = useSelector((state) => state.vehicle.selected);
  const user = useSelector((state) => state.user.profile);
  const review = useSelector((state) => state.reviews.byOrder);
  const addOnsOrder = useSelector((state) => state.detailOrder.addOns);

  const isImprovUpdateDataEnabled = useFliptBoolean(
    'FLAG_FE_IMPROVEMENT_UPDATE_DATA_ORDER',
    false,
    user.id || 'anonymous',
  );
  const isMenuInfluencerEnabled = useFliptBoolean('FLAG_FE_INFLUENCER_MENU', false, user.id || 'anonymous');
  const isThirdAnniversaryVoucherEnabled = useFliptBoolean(
    'FLAG_FE_THIRD_ANNIVERSARY_VOUCHER',
    false,
    user?.id || 'anonymous',
  );
  const isAirportIdentityReviewEnabled = useFliptBoolean('FLAG_FE_REVIEW_IDENTITY_AIRPORT', false, 'anonymous');
  const isUploadNewDocumentEnabled = useFliptBoolean('FLAG_FE_NEW_UPLOAD_DOCUMENT', false, 'anonymous');
  const isB2BPartnerIntegrationEnabled = useFliptBoolean('ENABLE_B2B_PARTNER_INTEGRATION', false, 'anonymous');

  const backHandler = () => {
    navigate(-1);
  };

  const handleExportToPdf = async () => {
    try {
      await dispatch(downloadOrderDetail(data?.transaction_key)).unwrap();
    } catch (error) {
      showToast({ type: 'error', message: 'Gagal Export ke PDF' });
    }
  };

  const handleRequestCancelOrder = () => {
    const payload = {
      transaction_key: data.transaction_key,
      status: 'REFUNDED',
    };

    setShowConfirmation({
      message: 'Apakah anda yakin ingin membatalkan pesanan ini?',
      show: true,
      onClick: async () => {
        setShowRejectOrderModal(false);

        try {
          setShowSpinner(true);
          trackEvent('order_cancellation_confirmed', {
            order_id: data?.transaction_key,
            source: 'detail_order_airport_transfer_regular',
          });
          await dispatch(updateOrderCancelation(payload)).unwrap();
          showToast({ type: 'success', message: 'Berhasil Membatalkan Pesanan' });
          navigate(-1);
        } catch (err) {
          showToast({ type: 'error', message: 'Gagal Membatalkan Pesanan!' });
        } finally {
          setShowSpinner(false);
        }
      },
    });
  };

  const timezone = !data?.order_detail?.loc_time_id ? '' : getLocationTimezone(data?.order_detail?.loc_time_id);
  const isOrderCancelled = data?.order_status === 'CANCELLED';
  const isOrderFinished = data?.order_status === 'FINISHED';
  const showCancelOrderBtn = !isOrderCancelled && !isOrderFinished && !data.order_approval_status;
  const isVendorOrder = Boolean(data?.vendor_partnership_id);

  useEffect(() => {
    if (
      data.order_status === 'COMPLETED' ||
      data.order_status === 'FINISHED' ||
      (data.order_status === 'PAID' && data.is_admin_creation)
    ) {
      if (!data || checkEmptyObject(data)) return;

      const choosedCar = {
        category: data.order_detail.vehicle?.category?.name,
        disability_allowed: data.order_detail.vehicle?.disability_allowed,
        images: data.order_detail.vehicle?.photo,
        licence_number: data.order_detail.vehicle?.license_number,
        max_passenger: data.order_detail.vehicle?.max_passanger,
        max_suitecase: data.order_detail.vehicle?.max_suitcase,
        package_id: data.airport_transfer_package_id,
        package_price: data.order_airport_package?.price,
        pet_allowed: data.order_detail.vehicle?.pet_allowed,
        price_with_driver: data.order_detail.vehicle?.price_with_driver,
        promo: data.order_detail.vehicle?.promo,
        required_driver: data.order_detail.vehicle?.required_driver,
        slash_price: data.order_detail.vehicle?.slash_price,
        smoke_allowed: data.order_detail.vehicle?.smoke_allowed,
        support_driver: data.order_detail.vehicle?.support_driver,
        transmission: data.order_detail.vehicle?.transmission,
        vehicle_id: data.order_detail.vehicle?.id,
        vehicle_image: data.order_detail.vehicle?.photo[0]?.name,
        vehicle_name: data.order_detail.vehicle?.name,
      };
      setSelectedCar(choosedCar);
    }
  }, [data.order_status]);

  return (
    <div className="detail-order-airport">
      <div className="detail-order-airport__back-btn" onClick={backHandler}>
        <LeftArrow />
        <p>Kembali</p>
      </div>
      <TableWrapper
        icon={<AirportIcon fill="#009EF7" width="25px" height="25px" />}
        title="Airport Transfer"
        showExportButton
        onExportToPdf={handleExportToPdf}
        CustomFilterComponent={
          Object.prototype.hasOwnProperty.call(data, 'order_approval_history') ? (
            <div className="btn-export">
              <Button variant="primary" onClick={() => setShowPriceDifference(true)}>
                Detail Perbedaan
              </Button>
            </div>
          ) : null
        }
      >
        {(data?.order_status === 'PAID' || data?.order_status === 'COMPLETED' || data?.order_status === 'FINISHED') &&
          !data.order_approval_status && (
            <div className="detail-order-airport__selection">
              {/* SELECT CAR */}
              <SelectFieldAirportTransferCar
                label="Pilih Mobil"
                htmlFor="pilih-mobil"
                placeholder="Cari Mobil.."
                data={allVehicle}
                selectedCar={selectedCar}
                onSelectCar={setSelectedCar}
                value={vehicleInput}
                onChange={(e) => setVehicleInput(e.target.value)}
                onClick={(vehicleId, resetVehicle) => {
                  if (vehicleId === '') {
                    setVehicleInput(resetVehicle);
                    return;
                  }
                  dispatch(getVehicleById(vehicleId));
                  setVehicleInput(resetVehicle);
                }}
                disable={data.order_status !== 'PAID'}
              />
            </div>
          )}
        {data?.order_approval_status?.includes('UPDATE_ORDER') ? (
          <Tabs activeTab={activeTab} setActiveTab={setActiveTab}>
            <TabPane label="Data Sekarang">
              <div className="detail-order-airport__renter-detail">
                <div className="detail-order-airport__renter-detail-title">
                  <h1>Detail Penyewa</h1>
                </div>
                <div className="detail-order-airport__renter-detail-body">
                  <InputField label="Nama Lengkap" disabled value={newOrderData?.user_name || '-'} />
                  <InputField label="Email" disabled value={newOrderData?.email || '-'} />

                  <div className="detail-order-airport__renter-detail-body__phone-number">
                    <InputField
                      label="No Handphone"
                      disabled
                      value={
                        newOrderData?.is_admin_creation ? newOrderData?.phone_country_code : customer?.phone_code || '-'
                      }
                      icon={
                        <img
                          src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                          width={26}
                          height={16}
                          alt={selectedCountry?.name + ' nation flag'}
                        />
                      }
                    />
                    <InputField value={newOrderData?.phone_number || '-'} disabled />
                  </div>

                  <InputField label="Negara" disabled value={selectedCountry?.name || '-'} />

                  <div className="detail-order-airport__renter-detail-body__phone-number">
                    <div className="detail-order-airport__renter-detail-body__phone-number-wrapper">
                      <InputField
                        label="Whatsapp"
                        disabled
                        value={
                          newOrderData?.is_admin_creation
                            ? newOrderData?.phone_country_code
                            : customer?.phone_code || '-'
                        }
                        icon={
                          <img
                            src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                            width={26}
                            height={16}
                            alt={selectedCountry?.name + ' nation flag'}
                          />
                        }
                      />
                      <div className="detail-order-airport__renter-detail-body__image-wrapper"></div>
                    </div>
                    <InputField disabled value={newOrderData?.wa_number || '-'} />
                  </div>
                </div>

                <div className="detail-order-airport__identity-detail-body">
                  <ImageViewer
                    label="KTP"
                    value={getKTPValue(data, customer, isUploadNewDocumentEnabled)}
                    onClick={imagePreviewHandler}
                  />
                </div>
              </div>

              {newOrderData?.order_detail?.is_for_other_person && (
                <div className="detail-order-airport__renter-detail">
                  <div className="detail-order-airport__renter-detail-title">
                    <h1>Detail Pemesan</h1>
                  </div>
                  <div className="detail-order-airport__renter-detail-body">
                    <InputField
                      label="Nama Lengkap"
                      disabled
                      value={newOrderData?.order_detail?.other_person_name || '-'}
                    />
                    <InputField label="Email" disabled value={newOrderData?.order_detail?.other_person_email || '-'} />

                    <div className="detail-order-airport__renter-detail-body__phone-number">
                      <InputField
                        label="No Handphone"
                        disabled
                        value={newOrderData?.order_detail?.other_person_phone_cc || '-'}
                        icon={
                          <img
                            src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                            width={26}
                            height={16}
                            alt={selectedCountry?.name + ' nation flag'}
                          />
                        }
                      />
                      <InputField value={newOrderData?.order_detail?.other_person_phone || '-'} disabled />
                    </div>
                  </div>
                </div>
              )}

              <div className="detail-order-airport__rent-detail">
                <div className="detail-order-airport__rent-detail-title">
                  <h1>Detail Order</h1>
                </div>
                <div className="detail-order-airport__rent-detail-body">
                  <InputField
                    label="Lokasi Penjemputan"
                    disabled
                    value={newOrderData?.order_detail?.rental_delivery_location || '-'}
                  />
                  <InputField
                    label="Lokasi Pengantaran"
                    disabled
                    value={newOrderData?.order_detail?.rental_return_location || '-'}
                  />
                  <InputField
                    label="Detail Lokasi Penjemputan"
                    disabled
                    value={newOrderData?.order_detail?.rental_delivery_location_detail || '-'}
                  />
                  <InputField
                    label="Detail Lokasi Pengantaran"
                    disabled
                    value={newOrderData?.order_detail?.rental_return_location_detail || '-'}
                  />
                  <div className="detail-order__rent-detail-body__rent-date">
                    <InputField
                      label="Tanggal"
                      disabled
                      value={
                        newOrderData?.order_detail?.start_booking_date
                          ? indonesianDateFormat(newOrderData?.order_detail?.start_booking_date)
                          : '-'
                      }
                    />
                    <InputField
                      label="Jam"
                      disabled
                      value={(newOrderData?.order_detail?.start_booking_time || '-') + ' ' + timezone}
                    />
                  </div>
                  <InputField
                    label="Nomor Penerbangan"
                    disabled
                    value={newOrderData?.order_detail?.flight_number || '-'}
                  />
                  <TextAreaInput
                    style={{
                      height:
                        newOrderData?.airport_package_vehicle_type?.split(', ').length >= 10
                          ? 96
                          : newOrderData?.airport_package_vehicle_type?.split(', ').length >= 5
                          ? 44 * 2
                          : 44,
                    }}
                    label="Jenis Mobil"
                    disabled
                    value={newOrderData?.airport_package_vehicle_type ?? '-'}
                    className="text-area-car-package"
                  />

                  <div
                    className={clsx(
                      'detail-order__rent-detail-body__rent-date',
                      isImprovUpdateDataEnabled ? 'col-full' : '',
                    )}
                  >
                    <InputField
                      label="Kapasitas Koper"
                      disabled
                      value={
                        newOrderData?.order_status === 'PENDING' || newOrderData?.order_status === 'CHECKOUT'
                          ? airportPackageVehicle?.max_suitecase
                          : newOrderData?.order_status === 'PAID' && !selectedCar
                          ? airportPackageVehicle?.max_suitecase
                          : vehicleById?.max_suitcase ?? '-'
                      }
                    />
                    {!isImprovUpdateDataEnabled && (
                      <InputField label="Koper yang dibawa" disabled value={newOrderData?.order_detail?.baggage ?? 0} />
                    )}
                  </div>

                  {isImprovUpdateDataEnabled && (
                    <div className="detail-order__rent-detail-body__rent-date">
                      <InputField
                        label="Penumpang"
                        disabled
                        value={
                          formatPassengerCount(
                            newOrderData?.order_detail?.adult_passenger,
                            newOrderData?.order_detail?.child_passenger,
                          ) || '-'
                        }
                      />
                      <InputField
                        label="Koper"
                        disabled
                        value={
                          newOrderData?.order_detail?.baggage ? newOrderData?.order_detail?.baggage + ' Suitcase' : '-'
                        }
                      />
                    </div>
                  )}

                  {newOrderData?.customer_name_meet_and_greet ? (
                    <InputField
                      label="Meet and Greet Board"
                      disabled
                      value={newOrderData.customer_name_meet_and_greet || '-'}
                    />
                  ) : null}
                </div>
              </div>

              <div className="detail-order-airport__price-detail">
                <div className="detail-order-airport__price-detail-title">
                  <h1>Rincian Biaya</h1>
                </div>

                <div className="detail-order-airport__price-detail-body">
                  <InputField
                    label="Biaya Sewa Mobil"
                    disabled
                    value={setCurrency(newOrderData?.booking_price) || '-'}
                  />
                  <InputField
                    label="Biaya Pengantaran"
                    disabled
                    value={setCurrency(newOrderData?.rental_delivery_fee) || '-'}
                  />
                  {newOrderData?.outside_operational_charge > 0 && (
                    <InputField
                      label="Outside Operational Hour Charge"
                      disabled
                      value={setCurrency(newOrderData?.outside_operational_charge) || '-'}
                    />
                  )}
                  {newOrderData?.price_component
                    ?.filter((item) => item?.type === 'charges')
                    ?.map((item, idx) => (
                      <InputField
                        key={idx}
                        label={`Holiday Charge (${item?.label})`}
                        disabled
                        value={setCurrency(item?.amount) || '-'}
                      />
                    ))}
                  <InputField
                    label="Pembayaran Dengan Point"
                    disabled
                    value={newOrderData?.point}
                    icon={<PointsIcon />}
                    iconPosition="start"
                  />
                  <InputField
                    label="Charge Payment Gateway Platform"
                    disabled
                    value={setCurrency(newOrderData?.disbursement?.total_amount_external_payment_fee) || '-'}
                  />
                  <InputField
                    label="Customer Service Platform"
                    disabled
                    value={setCurrency(newOrderData?.disbursement?.total_amount_customer_service_fee) || '-'}
                  />
                  {newOrderData?.fee_meet_greet_board ? (
                    <InputField
                      label="Meet and Greet Board"
                      disabled
                      value={newOrderData?.fee_meet_greet_board ? setCurrency(newOrderData.fee_meet_greet_board) : '-'}
                    />
                  ) : null}
                  <InputField
                    label="Total Keseluruhan"
                    disabled
                    value={setCurrency(newOrderData?.total_payment) || '-'}
                  />
                </div>
              </div>

              <div className="detail-order__voucher-detail">
                <div className="detail-order__voucher-detail-title">
                  <h1>Voucher</h1>
                </div>
                {isThirdAnniversaryVoucherEnabled && newOrderData?.vouchers?.length > 0 ? (
                  newOrderData.vouchers.map((vou) => (
                    <div className="detail-order__voucher-detail-body" key={vou.id} style={{ marginBottom: '42px' }}>
                      <InputField label="Nama Voucher" disabled value={vou?.name || '-'} />
                      <InputField label="Kode Voucher" disabled value={vou?.code || '-'} />
                      <InputField label="Harga Potongan" disabled value={vou?.value ? setCurrency(vou.value) : '-'} />
                    </div>
                  ))
                ) : (
                  <div className="detail-order__voucher-detail-body">
                    <InputField label="Nama Voucher" disabled value={newOrderData?.vouchers?.[0].name || '-'} />
                    <InputField label="Kode Voucher" disabled value={newOrderData?.vouchers?.[0].code || '-'} />
                    <InputField
                      label="Harga Potongan"
                      disabled
                      value={setCurrency(newOrderData?.vouchers?.[0].value) || '-'}
                    />
                  </div>
                )}
              </div>

              <AddOnsField data={newOrderData?.addons} totalPrice={newOrderData?.addon_total_price} />

              <div className="detail-order-airport__payment-detail">
                <div className="detail-order-airport__payment-detail-title">
                  <h1>Pembayaran</h1>
                </div>
                <div className="detail-order-airport__payment-detail-body">
                  <InputField label="Status Pembayaran" disabled value={data?.order_status || '-'} />

                  <div className={clsx('detail-order-airport__payment-detail-body__payment-method confirmation')}>
                    <InputField
                      label="Metode Pembayaran"
                      disabled
                      // value={data?.disbursement?.payment?.method ? data?.disbursement.payment.method : '-'}
                      value={getPaymentMethodString(data?.disbursement_recalculate)}
                    />
                    {data.order_status === 'CHECKOUT' &&
                    data?.order_approval_status !== 'WAITING_APPROVAL_DELETE_ORDER' ? (
                      <Button
                        height={44}
                        onClick={() => setShowBankTransferConfirmation(true)}
                        disabled={isPaymentValid}
                      >
                        Konfirmasi
                      </Button>
                    ) : null}
                  </div>

                  {data.order_status !== 'CHECKOUT' &&
                  data.order_status !== 'RECONFIRMATION' &&
                  Object.prototype.hasOwnProperty.call(data, 'disbursement') ? (
                    <>
                      <InputField
                        label="Nama Rekening"
                        disabled
                        value={
                          Object.prototype.hasOwnProperty.call(data, 'disbursement_reconfirmation')
                            ? [...data.disbursement_reconfirmation].pop()?.sender_name
                            : data?.disbursement?.sender_name || '-'
                        }
                      />

                      <InputField
                        label="Nama Bank"
                        disabled
                        value={
                          Object.prototype.hasOwnProperty.call(data, 'disbursement_reconfirmation')
                            ? [...data.disbursement_reconfirmation].pop()?.sender_bank_name
                            : data?.disbursement?.sender_bank_name || '-'
                        }
                      />

                      <div className="detail-order__payment-detail-body__preview-image">
                        <InputField
                          label="Foto Bukti Transfer"
                          disabled
                          value={getFileName(
                            Object.prototype.hasOwnProperty.call(data, 'disbursement_reconfirmation')
                              ? [...data.disbursement_reconfirmation].pop()?.reconfirmation_image
                              : data?.disbursement?.disbursement_confirmation_image,
                          )}
                          className="preview-image-input"
                        />

                        <Button
                          bgColor="#D9D9D9"
                          textColor="#000000"
                          className="preview-image-btn"
                          onClick={() =>
                            imagePreviewHandler(
                              Object.prototype.hasOwnProperty.call(data, 'disbursement_reconfirmation')
                                ? [...data.disbursement_reconfirmation].pop()?.reconfirmation_image
                                : data?.disbursement?.disbursement_confirmation_image,
                            )
                          }
                        >
                          Lihat
                        </Button>
                      </div>
                      <div />
                    </>
                  ) : null}
                </div>
              </div>

              <div className="detail-order-airport__transaction-buttons">
                <Button variant="outline" className="button" width={208} size="sm" onClick={backHandler}>
                  Kembali
                </Button>
              </div>
            </TabPane>
            <TabPane label="Data Sebelum">
              <div className="detail-order-airport__renter-detail">
                <div className="detail-order-airport__renter-detail-title">
                  <h1>Detail Penyewa</h1>
                </div>
                <div className="detail-order-airport__renter-detail-body">
                  <InputField label="Nama Lengkap" disabled value={oldOrderData?.user_name || '-'} />
                  <InputField label="Email" disabled value={oldOrderData?.email || '-'} />

                  <div className="detail-order-airport__renter-detail-body__phone-number">
                    <InputField
                      label="No Handphone"
                      disabled
                      value={
                        oldOrderData?.is_admin_creation ? oldOrderData?.phone_country_code : customer?.phone_code || '-'
                      }
                      icon={
                        <img
                          src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                          width={26}
                          height={16}
                          alt={selectedCountry?.name + ' nation flag'}
                        />
                      }
                    />
                    <InputField value={oldOrderData?.phone_number || '-'} disabled />
                  </div>

                  <InputField label="Negara" disabled value={selectedCountry?.name || '-'} />

                  <div className="detail-order-airport__renter-detail-body__phone-number">
                    <div className="detail-order-airport__renter-detail-body__phone-number-wrapper">
                      <InputField
                        label="Whatsapp"
                        disabled
                        value={
                          oldOrderData?.is_admin_creation
                            ? oldOrderData?.phone_country_code
                            : customer?.phone_code || '-'
                        }
                        icon={
                          <img
                            src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                            width={26}
                            height={16}
                            alt={selectedCountry?.name + ' nation flag'}
                          />
                        }
                      />
                      <div className="detail-order-airport__renter-detail-body__image-wrapper"></div>
                    </div>
                    <InputField disabled value={oldOrderData?.wa_number || '-'} />
                  </div>
                </div>

                <div className="detail-order-airport__identity-detail-body">
                  <ImageViewer
                    label="KTP"
                    value={getKTPValue(data, customer, isUploadNewDocumentEnabled)}
                    onClick={imagePreviewHandler}
                  />
                </div>
              </div>

              {oldOrderData?.order_detail?.is_for_other_person && (
                <div className="detail-order-airport__renter-detail">
                  <div className="detail-order-airport__renter-detail-title">
                    <h1>Detail Pemesan</h1>
                  </div>
                  <div className="detail-order-airport__renter-detail-body">
                    <InputField
                      label="Nama Lengkap"
                      disabled
                      value={oldOrderData?.order_detail?.other_person_name || '-'}
                    />
                    <InputField label="Email" disabled value={oldOrderData?.order_detail?.other_person_email || '-'} />

                    <div className="detail-order-airport__renter-detail-body__phone-number">
                      <InputField
                        label="No Handphone"
                        disabled
                        value={oldOrderData?.order_detail?.other_person_phone_cc || '-'}
                        icon={
                          <img
                            src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                            width={26}
                            height={16}
                            alt={selectedCountry?.name + ' nation flag'}
                          />
                        }
                      />
                      <InputField value={oldOrderData?.order_detail?.other_person_phone || '-'} disabled />
                    </div>
                  </div>
                </div>
              )}

              <div className="detail-order-airport__rent-detail">
                <div className="detail-order-airport__rent-detail-title">
                  <h1>Detail Order</h1>
                </div>
                <div className="detail-order-airport__rent-detail-body">
                  <InputField
                    label="Lokasi Penjemputan"
                    disabled
                    value={oldOrderData?.order_detail?.rental_delivery_location || '-'}
                  />
                  <InputField
                    label="Lokasi Pengantaran"
                    disabled
                    value={oldOrderData?.order_detail?.rental_return_location || '-'}
                  />
                  <InputField
                    label="Detail Lokasi Penjemputan"
                    disabled
                    value={oldOrderData?.order_detail?.rental_delivery_location_detail || '-'}
                  />
                  <InputField
                    label="Detail Lokasi Pengantaran"
                    disabled
                    value={oldOrderData?.order_detail?.rental_return_location_detail || '-'}
                  />
                  <div className="detail-order__rent-detail-body__rent-date">
                    <InputField
                      label="Tanggal"
                      disabled
                      value={
                        oldOrderData?.order_detail?.start_booking_date
                          ? indonesianDateFormat(oldOrderData?.order_detail?.start_booking_date)
                          : '-'
                      }
                    />
                    <InputField
                      label="Jam"
                      disabled
                      value={(oldOrderData?.order_detail?.start_booking_time || '-') + ' ' + timezone}
                    />
                  </div>
                  <InputField
                    label="Nomor Penerbangan"
                    disabled
                    value={oldOrderData?.order_detail?.flight_number || '-'}
                  />
                  <TextAreaInput
                    style={{
                      height:
                        oldOrderData?.airport_package_vehicle_type?.split(', ').length >= 10
                          ? 96
                          : oldOrderData?.airport_package_vehicle_type?.split(', ').length >= 5
                          ? 44 * 2
                          : 44,
                    }}
                    label="Jenis Mobil"
                    disabled
                    value={oldOrderData?.airport_package_vehicle_type ?? '-'}
                    className="text-area-car-package"
                  />

                  <div
                    className={clsx(
                      'detail-order__rent-detail-body__rent-date',
                      isImprovUpdateDataEnabled ? 'col-full' : '',
                    )}
                  >
                    <InputField
                      label="Kapasitas Koper"
                      disabled
                      value={
                        oldOrderData?.order_status === 'PENDING' || oldOrderData?.order_status === 'CHECKOUT'
                          ? airportPackageVehicle?.max_suitecase
                          : oldOrderData?.order_status === 'PAID' && !selectedCar
                          ? airportPackageVehicle?.max_suitecase
                          : vehicleById?.max_suitcase ?? '-'
                      }
                    />
                    {!isImprovUpdateDataEnabled && (
                      <InputField label="Koper yang dibawa" disabled value={oldOrderData?.order_detail?.baggage ?? 0} />
                    )}
                  </div>

                  {isImprovUpdateDataEnabled && (
                    <div className="detail-order__rent-detail-body__rent-date">
                      <InputField
                        label="Penumpang"
                        disabled
                        value={
                          formatPassengerCount(
                            oldOrderData?.order_detail?.adult_passenger,
                            oldOrderData?.order_detail?.child_passenger,
                          ) || '-'
                        }
                      />
                      <InputField
                        label="Koper"
                        disabled
                        value={
                          oldOrderData?.order_detail?.baggage ? oldOrderData?.order_detail?.baggage + ' Suitcase' : '-'
                        }
                      />
                    </div>
                  )}

                  {oldOrderData?.customer_name_meet_and_greet ? (
                    <InputField
                      label="Meet and Greet Board"
                      disabled
                      value={oldOrderData.customer_name_meet_and_greet || '-'}
                    />
                  ) : null}
                </div>
              </div>

              <div className="detail-order-airport__price-detail">
                <div className="detail-order-airport__price-detail-title">
                  <h1>Rincian Biaya</h1>
                </div>

                <div className="detail-order-airport__price-detail-body">
                  <InputField
                    label="Biaya Sewa Mobil"
                    disabled
                    value={setCurrency(oldOrderData?.booking_price) || '-'}
                  />
                  <InputField
                    label="Biaya Pengantaran"
                    disabled
                    value={setCurrency(oldOrderData?.rental_delivery_fee) || '-'}
                  />
                  {oldOrderData?.outside_operational_charge > 0 && (
                    <InputField
                      label="Outside Operational Hour Charge"
                      disabled
                      value={setCurrency(oldOrderData?.outside_operational_charge) || '-'}
                    />
                  )}
                  {oldOrderData?.price_component
                    ?.filter((item) => item?.type === 'charges')
                    ?.map((item, idx) => (
                      <InputField
                        key={idx}
                        label={`Holiday Charge (${item?.label})`}
                        disabled
                        value={setCurrency(item?.amount) || '-'}
                      />
                    ))}
                  <InputField
                    label="Pembayaran Dengan Point"
                    disabled
                    value={oldOrderData?.point}
                    icon={<PointsIcon />}
                    iconPosition="start"
                  />
                  <InputField
                    label="Charge Payment Gateway Platform"
                    disabled
                    value={setCurrency(oldOrderData?.disbursement?.total_amount_external_payment_fee) || '-'}
                  />
                  <InputField
                    label="Customer Service Platform"
                    disabled
                    value={setCurrency(oldOrderData?.disbursement?.total_amount_customer_service_fee) || '-'}
                  />

                  {oldOrderData?.fee_meet_greet_board ? (
                    <InputField
                      label="Meet and Greet Board"
                      disabled
                      value={oldOrderData?.fee_meet_greet_board ? setCurrency(oldOrderData.fee_meet_greet_board) : '-'}
                    />
                  ) : null}

                  <InputField
                    label="Total Keseluruhan"
                    disabled
                    value={setCurrency(oldOrderData?.total_payment) || '-'}
                  />
                </div>
              </div>

              <div className="detail-order__voucher-detail">
                <div className="detail-order__voucher-detail-title">
                  <h1>Voucher</h1>
                </div>
                {isThirdAnniversaryVoucherEnabled && oldOrderData?.vouchers?.length > 0 ? (
                  oldOrderData.vouchers.map((vou) => (
                    <div className="detail-order__voucher-detail-body" key={vou.id} style={{ marginBottom: '42px' }}>
                      <InputField label="Nama Voucher" disabled value={vou?.name || '-'} />
                      <InputField label="Kode Voucher" disabled value={vou?.code || '-'} />
                      <InputField label="Harga Potongan" disabled value={vou?.value ? setCurrency(vou.value) : '-'} />
                    </div>
                  ))
                ) : (
                  <div className="detail-order__voucher-detail-body">
                    <InputField label="Nama Voucher" disabled value={oldOrderData?.vouchers?.[0].name || '-'} />
                    <InputField label="Kode Voucher" disabled value={oldOrderData?.vouchers?.[0].code || '-'} />
                    <InputField
                      label="Harga Potongan"
                      disabled
                      value={setCurrency(oldOrderData?.vouchers?.[0].value) || '-'}
                    />
                  </div>
                )}
              </div>

              <AddOnsField
                data={oldOrderData?.addons?.length > 0 ? oldOrderData?.addons : addOnsOrder}
                totalPrice={oldOrderData?.addon_total_price}
              />

              <div className="detail-order-airport__payment-detail">
                <div className="detail-order-airport__payment-detail-title">
                  <h1>Pembayaran</h1>
                </div>
                <div className="detail-order-airport__payment-detail-body">
                  <InputField label="Status Pembayaran" disabled value={data?.order_status || '-'} />

                  <div
                    className={clsx(
                      'detail-order-airport__payment-detail-body__payment-method',
                      data.order_status === 'CHECKOUT' ? 'confirmation' : 'not-confirmation',
                    )}
                  >
                    <InputField
                      label="Metode Pembayaran"
                      disabled
                      // value={data?.disbursement?.payment?.method ? data?.disbursement.payment.method : '-'}
                      value={getPaymentMethodString(data.disbursement)}
                    />
                  </div>

                  {data.order_status !== 'CHECKOUT' &&
                  data.order_status !== 'RECONFIRMATION' &&
                  Object.prototype.hasOwnProperty.call(data, 'disbursement') ? (
                    <>
                      <InputField
                        label="Nama Rekening"
                        disabled
                        value={
                          Object.prototype.hasOwnProperty.call(data, 'disbursement_reconfirmation')
                            ? [...data.disbursement_reconfirmation].pop()?.sender_name
                            : data?.disbursement?.sender_name || '-'
                        }
                      />

                      <InputField
                        label="Nama Bank"
                        disabled
                        value={
                          Object.prototype.hasOwnProperty.call(data, 'disbursement_reconfirmation')
                            ? [...data.disbursement_reconfirmation].pop()?.sender_bank_name
                            : data?.disbursement?.sender_bank_name || '-'
                        }
                      />

                      <div className="detail-order__payment-detail-body__preview-image">
                        <InputField
                          label="Foto Bukti Transfer"
                          disabled
                          value={getFileName(
                            Object.prototype.hasOwnProperty.call(data, 'disbursement_reconfirmation')
                              ? [...data.disbursement_reconfirmation].pop()?.reconfirmation_image
                              : data?.disbursement?.disbursement_confirmation_image,
                          )}
                          className="preview-image-input"
                        />

                        <Button
                          bgColor="#D9D9D9"
                          textColor="#000000"
                          className="preview-image-btn"
                          onClick={() =>
                            imagePreviewHandler(
                              Object.prototype.hasOwnProperty.call(data, 'disbursement_reconfirmation')
                                ? [...data.disbursement_reconfirmation].pop()?.reconfirmation_image
                                : data?.disbursement?.disbursement_confirmation_image,
                            )
                          }
                        >
                          Lihat
                        </Button>
                      </div>
                      <div />
                    </>
                  ) : null}
                </div>
              </div>

              <div className="detail-order-airport__transaction-buttons">
                <Button variant="outline" className="button" width={208} size="sm" onClick={backHandler}>
                  Kembali
                </Button>
              </div>
            </TabPane>
          </Tabs>
        ) : (
          <>
            {isB2BPartnerIntegrationEnabled && isVendorOrder ? (
              <div className="detail-order__partner-detail">
                <div className="detail-order__partner-detail-title">
                  <h1>Informasi Partner</h1>
                </div>

                <div className="detail-order__partner-detail-body">
                  <InputField label="Nama Lengkap" disabled value={data?.vendor_partnership?.name || '-'} />
                  <InputField label="Email" disabled value={data?.vendor_partnership?.email || '-'} />
                  <div className="detail-order__partner-detail-body__phone-number">
                    <InputField
                      label="No Handphone"
                      disabled
                      value={data?.vendor_partnership?.phone_code || '-'}
                      icon={
                        <img
                          src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                          width={26}
                          height={16}
                          alt={selectedCountry?.name + ' nation flag'}
                        />
                      }
                    />
                    <InputField value={data?.vendor_partnership?.phone || '-'} disabled />
                  </div>
                </div>
              </div>
            ) : null}

            <div className="detail-order-airport__renter-detail">
              <div className="detail-order-airport__renter-detail-title">
                <h1>Detail Penyewa</h1>
              </div>
              <div className="detail-order-airport__renter-detail-body">
                <InputField label="Nama Lengkap" disabled value={data?.user_name || '-'} />
                <InputField label="Email" disabled value={data?.email || '-'} />

                <div className="detail-order-airport__renter-detail-body__phone-number">
                  <InputField
                    label="No Handphone"
                    disabled
                    value={data?.phone_country_code || '-'}
                    icon={
                      <img
                        src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                        width={26}
                        height={16}
                        alt={selectedCountry?.name + ' nation flag'}
                      />
                    }
                  />
                  <InputField value={data?.phone_number || '-'} disabled />
                </div>

                <InputField label="Negara" disabled value={selectedCountry?.name || '-'} />

                <div className="detail-order-airport__renter-detail-body__phone-number">
                  <div className="detail-order-airport__renter-detail-body__phone-number-wrapper">
                    <InputField
                      label="Whatsapp"
                      disabled
                      value={data?.phone_country_code || '-'}
                      icon={
                        <img
                          src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                          width={26}
                          height={16}
                          alt={selectedCountry?.name + ' nation flag'}
                        />
                      }
                    />
                    <div className="detail-order-airport__renter-detail-body__image-wrapper"></div>
                  </div>
                  <InputField disabled value={data?.wa_number || '-'} />
                </div>
              </div>

              <div className="detail-order-airport__identity-detail-body">
                {isB2BPartnerIntegrationEnabled && isVendorOrder ? (
                  <ImageNotAvailable label="KTP" />
                ) : (
                  <ImageViewer
                    label="KTP"
                    value={getKTPValue(data, customer, isUploadNewDocumentEnabled)}
                    onClick={imagePreviewHandler}
                    customButton={
                      isAirportIdentityReviewEnabled &&
                      (data?.order_status === 'PAID' || data?.order_status === 'REVIEWING_IDENTITY') && (
                        <>
                          <Button type="button" onClick={() => setShowReviewIdentityModal({ type: 'ktp', show: true })}>
                            Tinjau
                          </Button>

                          {customer?.PersonalInfos?.need_review_ktp && (
                            <div className="reupload-icon">
                              <ReuploadIcon />
                              <p>Upload ulang KTP</p>
                            </div>
                          )}
                        </>
                      )
                    }
                  />
                )}
              </div>
            </div>

            {data?.order_detail?.is_for_other_person && (
              <div className="detail-order-airport__renter-detail">
                <div className="detail-order-airport__renter-detail-title">
                  <h1>Detail Pemesan</h1>
                </div>
                <div className="detail-order-airport__renter-detail-body">
                  <InputField label="Nama Lengkap" disabled value={data?.order_detail?.other_person_name || '-'} />
                  <InputField label="Email" disabled value={data?.order_detail?.other_person_email || '-'} />

                  <div className="detail-order-airport__renter-detail-body__phone-number">
                    <InputField
                      label="No Handphone"
                      disabled
                      value={data?.order_detail?.other_person_phone_cc || '-'}
                      icon={
                        <img
                          src={`https://flagcdn.com/w2560/${selectedCountry?.code?.toLowerCase()}.png`}
                          width={26}
                          height={16}
                          alt={selectedCountry?.name + ' nation flag'}
                        />
                      }
                    />
                    <InputField value={data?.order_detail?.other_person_phone || '-'} disabled />
                  </div>
                </div>
              </div>
            )}

            <div className="detail-order-airport__rent-detail">
              <div className="detail-order-airport__rent-detail-title">
                <h1>Detail Order</h1>
              </div>
              <div className="detail-order-airport__rent-detail-body">
                <InputField
                  label="Lokasi Penjemputan"
                  disabled
                  value={data?.order_detail?.rental_delivery_location || '-'}
                />
                <InputField
                  label="Lokasi Pengantaran"
                  disabled
                  value={data?.order_detail?.rental_return_location || '-'}
                />
                <InputField
                  label="Detail Lokasi Penjemputan"
                  disabled
                  value={data?.order_detail?.rental_delivery_location_detail || '-'}
                />
                <InputField
                  label="Detail Lokasi Pengantaran"
                  disabled
                  value={data?.order_detail?.rental_return_location_detail || '-'}
                />
                <div className="detail-order__rent-detail-body__rent-date">
                  <InputField
                    label="Tanggal"
                    disabled
                    value={
                      data?.order_detail?.start_booking_date
                        ? indonesianDateFormat(data?.order_detail?.start_booking_date)
                        : '-'
                    }
                  />
                  <InputField
                    label="Jam"
                    disabled
                    value={(data?.order_detail?.start_booking_time || '-') + ' ' + timezone}
                  />
                </div>
                <InputField label="Nomor Penerbangan" disabled value={data?.order_detail?.flight_number || '-'} />
                <TextAreaInput
                  style={{
                    height:
                      data?.airport_package_vehicle_type?.split(', ').length >= 10
                        ? 96
                        : data?.airport_package_vehicle_type?.split(', ').length >= 5
                        ? 44 * 2
                        : 44,
                  }}
                  label="Jenis Mobil"
                  disabled
                  value={data?.airport_package_vehicle_type ?? '-'}
                  className="text-area-car-package"
                />

                <div
                  className={clsx(
                    'detail-order__rent-detail-body__rent-date',
                    isImprovUpdateDataEnabled ? 'col-full' : '',
                  )}
                >
                  <InputField
                    label="Kapasitas Koper"
                    disabled
                    value={
                      data?.order_status === 'PENDING' || data?.order_status === 'CHECKOUT'
                        ? airportPackageVehicle?.max_suitecase
                        : data?.order_status === 'PAID' && !selectedCar
                        ? airportPackageVehicle?.max_suitecase
                        : vehicleById?.max_suitcase ?? '-'
                    }
                  />
                  {!isImprovUpdateDataEnabled && (
                    <InputField label="Koper yang dibawa" disabled value={data?.order_detail?.baggage ?? 0} />
                  )}
                </div>

                {isImprovUpdateDataEnabled && (
                  <div className="detail-order__rent-detail-body__rent-date">
                    <InputField
                      label="Penumpang"
                      disabled
                      value={
                        formatPassengerCount(
                          data?.order_detail?.adult_passenger,
                          data?.order_detail?.child_passenger,
                        ) || '-'
                      }
                    />
                    <InputField
                      label="Koper"
                      disabled
                      value={data?.order_detail?.baggage ? data?.order_detail?.baggage + ' Suitcase' : '-'}
                    />
                  </div>
                )}

                {data?.customer_name_meet_and_greet ? (
                  <InputField label="Meet and Greet Board" disabled value={data.customer_name_meet_and_greet || '-'} />
                ) : null}
              </div>
            </div>

            <div className="detail-order-airport__price-detail">
              <div className="detail-order-airport__price-detail-title">
                <h1>Rincian Biaya</h1>
              </div>

              <div className="detail-order-airport__price-detail-body">
                <InputField label="Biaya Sewa Mobil" disabled value={setCurrency(data?.booking_price) || '-'} />
                <InputField label="Biaya Pengantaran" disabled value={setCurrency(data?.rental_delivery_fee) || '-'} />
                {data?.outside_operational_charge > 0 && (
                  <InputField
                    label="Outside Operational Hour Charge"
                    disabled
                    value={setCurrency(data?.outside_operational_charge) || '-'}
                  />
                )}
                {data?.price_component
                  ?.filter((item) => item?.type === 'charges')
                  ?.map((item, idx) => (
                    <InputField
                      key={idx}
                      label={`Holiday Charge (${item?.label})`}
                      disabled
                      value={setCurrency(item?.amount) || '-'}
                    />
                  ))}
                <InputField
                  label="Pembayaran Dengan Point"
                  disabled
                  value={data?.point}
                  icon={<PointsIcon />}
                  iconPosition="start"
                />
                <InputField
                  label="Charge Payment Gateway Platform"
                  disabled
                  value={setCurrency(data?.disbursement?.total_amount_external_payment_fee) || '-'}
                />
                <InputField
                  label="Customer Service Platform"
                  disabled
                  value={setCurrency(data?.disbursement?.total_amount_customer_service_fee) || '-'}
                />

                {data?.fee_meet_greet_board ? (
                  <InputField
                    label="Meet and Greet Board"
                    disabled
                    value={data?.fee_meet_greet_board ? setCurrency(data.fee_meet_greet_board) : '-'}
                  />
                ) : null}

                <InputField
                  label="Total Harga Bersih"
                  disabled
                  value={setCurrency(data?.disbursement?.total_net_amount) || '-'}
                />
                <InputField
                  label="Total Bruto"
                  disabled
                  value={setCurrency(data?.disbursement?.total_amount_with_customer_service_fee) || '-'}
                />

                {isMenuInfluencerEnabled && data?.referral_discount ? (
                  <InputField label="Diskon Referral" disabled value={setCurrency(data?.referral_discount) || '-'} />
                ) : null}

                <InputField label="Total Keseluruhan" disabled value={setCurrency(data?.total_payment) || '-'} />
                {Object.prototype.hasOwnProperty.call(data, 'order_approval_history') ? (
                  <InputField
                    label="Harga Selisih"
                    disabled
                    value={setCurrency(data?.total_diff_price_with_approval) || '-'}
                  />
                ) : null}
              </div>
            </div>

            <div className="detail-order__voucher-detail">
              <div className="detail-order__voucher-detail-title">
                <h1>Voucher</h1>
              </div>
              {isThirdAnniversaryVoucherEnabled && data?.vouchers?.length > 0 ? (
                data.vouchers.map((vou) => (
                  <div className="detail-order__voucher-detail-body" key={vou.id} style={{ marginBottom: '42px' }}>
                    <InputField label="Nama Voucher" disabled value={vou?.name || '-'} />
                    <InputField label="Kode Voucher" disabled value={vou?.code || '-'} />
                    <InputField label="Harga Potongan" disabled value={vou?.value ? setCurrency(vou.value) : '-'} />
                  </div>
                ))
              ) : (
                <div className="detail-order__voucher-detail-body">
                  <InputField label="Nama Voucher" disabled value={data?.vouchers?.[0].name || '-'} />
                  <InputField label="Kode Voucher" disabled value={data?.vouchers?.[0].code || '-'} />
                  <InputField label="Harga Potongan" disabled value={setCurrency(data?.vouchers?.[0].value) || '-'} />
                </div>
              )}
            </div>

            <AddOnsField data={addOnsOrder} totalPrice={data?.addon_total_price} />

            <div className="detail-order-airport__payment-detail">
              <div className="detail-order-airport__payment-detail-title">
                <h1>Pembayaran</h1>
              </div>
              <div className="detail-order-airport__payment-detail-body">
                <InputField
                  label="Status Pembayaran"
                  disabled
                  value={isB2BPartnerIntegrationEnabled && isVendorOrder ? '-' : data?.order_status || '-'}
                />

                <div
                  className={clsx(
                    'detail-order-airport__payment-detail-body__payment-method',
                    data.order_status === 'CHECKOUT' ? 'confirmation' : 'not-confirmation',
                  )}
                >
                  <InputField
                    label="Metode Pembayaran"
                    disabled
                    // value={data?.disbursement?.payment?.method ? data?.disbursement.payment.method : '-'}
                    value={
                      isB2BPartnerIntegrationEnabled && isVendorOrder ? '-' : getPaymentMethodString(data.disbursement)
                    }
                  />
                  {data.order_status === 'CHECKOUT' &&
                  data?.order_approval_status !== 'WAITING_APPROVAL_DELETE_ORDER' ? (
                    <Button height={44} onClick={() => setShowBankTransferConfirmation(true)} disabled={isPaymentValid}>
                      Konfirmasi
                    </Button>
                  ) : null}
                </div>

                {data.order_status !== 'CHECKOUT' &&
                data.order_status !== 'RECONFIRMATION' &&
                Object.prototype.hasOwnProperty.call(data, 'disbursement') ? (
                  <>
                    <InputField
                      label="Nama Rekening"
                      disabled
                      value={
                        Object.prototype.hasOwnProperty.call(data, 'disbursement_reconfirmation')
                          ? [...data.disbursement_reconfirmation].pop()?.sender_name
                          : data?.disbursement?.sender_name || '-'
                      }
                    />

                    <InputField
                      label="Nama Bank"
                      disabled
                      value={
                        isB2BPartnerIntegrationEnabled && isVendorOrder
                          ? '-'
                          : Object.prototype.hasOwnProperty.call(data, 'disbursement_reconfirmation')
                          ? [...data.disbursement_reconfirmation].pop()?.sender_bank_name
                          : data?.disbursement?.sender_bank_name || '-'
                      }
                    />

                    <div className="detail-order__payment-detail-body__preview-image">
                      <InputField
                        label="Foto Bukti Transfer"
                        disabled
                        value={
                          isB2BPartnerIntegrationEnabled && isVendorOrder
                            ? '-'
                            : getFileName(
                                Object.prototype.hasOwnProperty.call(data, 'disbursement_reconfirmation')
                                  ? [...data.disbursement_reconfirmation].pop()?.reconfirmation_image
                                  : data?.disbursement?.disbursement_confirmation_image,
                              )
                        }
                        className="preview-image-input"
                      />

                      {!(isB2BPartnerIntegrationEnabled && isVendorOrder) ? (
                        <Button
                          bgColor="#D9D9D9"
                          textColor="#000000"
                          className="preview-image-btn"
                          onClick={() =>
                            imagePreviewHandler(
                              Object.prototype.hasOwnProperty.call(data, 'disbursement_reconfirmation')
                                ? [...data.disbursement_reconfirmation].pop()?.reconfirmation_image
                                : data?.disbursement?.disbursement_confirmation_image,
                            )
                          }
                        >
                          Lihat
                        </Button>
                      ) : null}
                    </div>
                    <div />
                  </>
                ) : null}
              </div>
            </div>

            {review.length > 0 && data.order_status === 'FINISHED' && (
              <div className="detail-order__review">
                <div className="detail-order__review-title">
                  <h1>Review dan Penilaian</h1>
                </div>

                <div className="detail-order__review-body">
                  <h2 className="detail-order__review-order-key">{data.order_key}</h2>

                  <div className="detail-order__review-car-info-wrapper">
                    <div className="image-container">
                      <img src={IMAGE_BASE_URL + data?.order_detail?.vehicle?.photo[0].name} alt="" />
                    </div>

                    <div className="car-info">
                      <h3 className="car-name">{data?.order_detail?.vehicle.name}</h3>

                      <div className="car-attribute">
                        <p>{data?.order_detail?.vehicle.max_passanger} Seats</p>
                        <span>&#x2022;</span>
                        <p>{data?.order_detail?.vehicle.max_suitcase} Koper</p>
                        <span>&#x2022;</span>
                        <p>Transmisi {data?.order_detail?.vehicle.transmission}</p>
                      </div>

                      <div className="rating-wrapper">
                        {Array(5)
                          .fill(0)
                          .map((_, index) => {
                            return <Star key={index} color={review[0].rating > index ? '#f1a33a' : '#a9a9a9'} />;
                          })}
                      </div>
                    </div>
                  </div>

                  {review[0].comment ? (
                    <div className="user-comment-wrapper">
                      <textarea
                        name="user-comment"
                        id=""
                        cols="30"
                        rows="10"
                        value={review[0].comment}
                        readOnly
                        disabled
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            )}

            <div className="detail-order-airport__transaction-buttons">
              <Button variant="outline" className="button" width={208} size="sm" onClick={backHandler}>
                Kembali
              </Button>
              {(data.order_status === 'CHECKOUT' || data.order_status === 'REVIEWING_IDENTITY') &&
              !data.order_approval_status ? (
                <Button
                  size="sm"
                  className="button"
                  width={208}
                  variant="danger"
                  onClick={() => setShowRejectOrderModal(true)}
                >
                  Tolak Pesanan
                </Button>
              ) : null}

              {showCancelOrderBtn ? (
                <Button size="sm" className="button" width={208} variant="danger" onClick={handleRequestCancelOrder}>
                  Cancel Order
                </Button>
              ) : null}

              {(data.order_status === 'PAID' ||
                (data.order_status === 'REVIEWING_IDENTITY' &&
                  !customer?.PersonalInfos?.need_review_sim &&
                  !customer?.PersonalInfos?.need_review_ktp)) &&
              !data.order_approval_status ? (
                <Button variant="success" className="button" width={208} size="sm" onClick={handleProcess}>
                  Proses
                </Button>
              ) : null}
            </div>
          </>
        )}
      </TableWrapper>
    </div>
  );
};

export default RegularOrderDetail;
